
import service from '../httpService'

const bankdetails ={
    namespaced: true,
    state : {
        bankdetailsList:[],
        bankLoader: false,
        bankupdateStatus: '',
        statusLoader: false
    },
    mutations:{
        setBankdetails(state, payload){
            state.bankdetailsList = payload
        },
        setBankLoader(state, payload){
            state.bankLoader = payload
        },
        setBankUpdateStatus(state, payload){
            state.bankupdateStatus = payload
        },
        setStatusLoader(state, payload){
            state.statusLoader = payload
        }
    },
    actions:{
        getBankDetailsList({state, commit, dispatch, rootState}, payload){
            try {
                commit('setBankLoader' , true)
                commit('setBankdetails' , [])
                service.getBankDetails(payload).then(resp =>{
                    if(resp.status == 200 && resp.data.result.length > 0){
                        commit('setBankdetails' , resp.data.result)
                    }
                }).finally(()=>{commit('setBankLoader' , false)})
            } catch (error){
                commit('setBankLoader' , false)
                commit('SET_SNAKBAR', { msg: error, show: true, color: 'red lighten-1', timeout: 3000 }, { root: true })
            }
            
        },
        getBankUpdateStatus({state, commit, dispatch} , payload){
            try{
                commit('setStatusLoader' , true)
                service.checkBankUpdate('').then(resp =>{
                    if(resp.status == 200 && resp.data.result.BankDetailsCount){
                        commit('setBankUpdateStatus' , resp.data.result)
                    }else{
                        commit('setBankUpdateStatus' , '')
                    }
                }).finally(()=>{ commit('setStatusLoader' , false) })
            }
            catch(error){
                commit('setStatusLoader' , false)
                commit('SET_SNAKBAR', { msg: error, show: true, color: 'red lighten-1', timeout: 3000 }, { root: true })
            }
        }
    }
}

export default bankdetails